import { OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { ActivatedRoute } from '@angular/router';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';
import { ScriptInjectorService } from '../../core/services/script-injector.service';
import { environment } from '../../../environments/environment';
import * as fromAuth from '../../auth/reducers';
import * as fromSettings from '../../settings/reducers';
var MessagingPageComponent = /** @class */ (function () {
    function MessagingPageComponent(_store, _route, _scriptInjector) {
        this._store = _store;
        this._route = _route;
        this._scriptInjector = _scriptInjector;
    }
    MessagingPageComponent.prototype.ngOnInit = function () {
        this.conversationId$ = from(this._route.paramMap.pipe(map(function (params) {
            var id = params.get('conversationId');
            // != null catches null or undefined
            if (id != null) {
                return String(id);
            }
            return null;
        })));
        this.selectedLanguage$ = this._store.pipe(select(fromAuth.getLanguageCode));
        this.xSalveClinicToken$ = this._store.pipe(select(fromAuth.getClinicId));
        this.messagesText$ = this._store.pipe(select(fromSettings.getSectionTranslations('Messages')));
        this.clinicMessagingLoaded$ = from(this._scriptInjector
            .loadScript('salve-clinic-messaging', environment.messagingComponentUrl)
            .then(function () { return true; })
            .catch(function () { return false; }));
    };
    return MessagingPageComponent;
}());
export { MessagingPageComponent };
